// docs/04-routing-and-layouts.md — build URLs here, not with string concatenation.
export const routes = {
  dashboard: () => "/dashboard",
  users: () => "/administration/users",
  user: (id: string) => `/administration/users/${encodeURIComponent(id)}`,
  auditLog: () => "/administration/audit-log",
  companyStructure: () => "/master-data/company-structure",
  departments: () => "/master-data/departments",
  units: () => "/master-data/units",
  categories: () => "/master-data/categories",
  items: () => "/master-data/items",
  newItem: () => "/master-data/items/new",
  item: (id: string, tab?: string) =>
    `/master-data/items/${encodeURIComponent(id)}${tab ? `?tab=${tab}` : ""}`,
  editItem: (id: string) => `/master-data/items/${encodeURIComponent(id)}/edit`,
  lots: () => "/master-data/lots",
  lot: (id: string) => `/master-data/lots/${encodeURIComponent(id)}`,
  roles: () => "/administration/roles",
  login: () => "/login",
  forgotPassword: () => "/forgot-password",
  acceptInvite: () => "/accept-invite",
  verifyEmail: () => "/verify-email",
  mfaSetup: () => "/mfa-setup",
  security: () => "/account/security",
  approvals: () => "/approvals",
  notifications: () => "/notifications",
  approvalWorkflows: () => "/administration/approval-workflows",
  /** The shared UI kit demo (FND-16): dev/test only, not in the nav. */
  kit: () => "/__kit",
} as const;
